export const templates = (state) => {
  return state.templates
}
